/**
 * DATEV Standard-BWA Form 01 line schema (32 Zeilen), one file per SKR generated from
 * src/_console/skr/BWA-Schema_SKR_0N.xlsx via `node src/_console/bwaSchemaExport.js -s N`.
 */
export interface BwaFormulaTerm {
    readonly zeile: number;
    /** +1 = added, -1 = subtracted, exactly as the sheet's Rechenlogik column */
    readonly sign: 1 | -1;
}

interface BwaSchemaRowBase {
    /** DATEV BWA-Zeile number, unique per schema; used as the row key */
    readonly zeile: number;
    /** DATEV Kennzeichen A-I of the Zwischensummen, null on account lines */
    readonly kennz: string | null;
    /** German label from the sheet, informational (rendering goes through i18n) */
    readonly label: string;
    /** Ertrag lines are Haben-positive, Aufwand lines Soll-positive; derived from the formulas by the generator */
    readonly nature: "ertrag" | "aufwand";
}

export interface BwaSchemaAccountRow extends BwaSchemaRowBase {
    /** inclusive 4-digit account ranges */
    readonly ranges: readonly (readonly [number, number])[];
}

export interface BwaSchemaSumRow extends BwaSchemaRowBase {
    /** signed sum of earlier rows */
    readonly formula: readonly BwaFormulaTerm[];
}

export type BwaSchemaRow = BwaSchemaAccountRow | BwaSchemaSumRow;

export const isBwaSumRow = (row: BwaSchemaRow): row is BwaSchemaSumRow => "formula" in row;
